import axios from 'axios';
export default (employeeId, reason) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}employees/${employeeId}`, {
        headers: {
          'x-ooca-delete-reason': reason,
        },
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
